import { Plus, X } from 'lucide-react';

// Génération en lot (admin) : sujets additionnels (titre + consignes) + progression du batch.
export default function AiBatchSection({ rows, onAdd, onUpdate, onRemove, progress, generating }) {
    return (
        <>
            <div style={{ marginTop: 10, padding: 10, border: '1px dashed var(--border)', borderRadius: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <span style={{ fontSize: '0.85em', color: 'var(--text-muted)' }}>
                        <strong>Génération en lot</strong> (admin) — chaque sujet sera généré séquentiellement avec le même nombre de questions
                    </span>
                    <button type="button" onClick={onAdd} disabled={generating}
                        className="admin-btn admin-btn--xs admin-btn--secondary"
                        title="Ajouter un sujet supplémentaire à générer">
                        <Plus size={12} /> Ajouter un sujet
                    </button>
                </div>

                {rows.length === 0 ? (
                    <p style={{ fontSize: '0.78em', color: 'var(--text-muted)', fontStyle: 'italic', margin: 0 }}>
                        Clique sur « Ajouter un sujet » pour générer plusieurs sujets d'un coup.
                    </p>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {rows.map((row, idx) => (
                            <div key={idx} style={{ padding: 8, background: 'rgba(0,0,0,0.15)', borderRadius: 6 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                                    <span style={{ fontSize: '0.78em', color: 'var(--text-muted)', minWidth: 28 }}>#{idx + 2}</span>
                                    <input
                                        type="text"
                                        placeholder={`Titre du sujet ${idx + 2}`}
                                        value={row.label}
                                        onChange={e => onUpdate(idx, 'label', e.target.value)}
                                        maxLength={100}
                                        disabled={generating}
                                        style={{ flex: 1, fontSize: '0.88em' }}
                                    />
                                    <button type="button" onClick={() => onRemove(idx)} disabled={generating}
                                        title="Supprimer ce sujet"
                                        style={{ background: 'transparent', border: 'none', color: 'var(--danger, #ef4444)', cursor: 'pointer', padding: 4 }}>
                                        <X size={14} />
                                    </button>
                                </div>
                                <textarea
                                    placeholder={`Consignes pour le sujet ${idx + 2} (10 caractères min)`}
                                    value={row.consignes}
                                    onChange={e => onUpdate(idx, 'consignes', e.target.value)}
                                    disabled={generating}
                                    rows={3}
                                    style={{ width: '100%', resize: 'vertical', fontSize: '0.85em', boxSizing: 'border-box' }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Progression batch */}
            {progress && progress.total > 1 && (
                <div style={{ marginTop: 8, padding: 8, background: 'rgba(124,58,237,0.1)', borderRadius: 6, fontSize: '0.85em' }}>
                    {generating
                        ? <>Génération en cours : <strong>{progress.current}/{progress.total}</strong>…</>
                        : <>Terminé : <strong>{progress.success}</strong> succès, <strong>{progress.errors.length}</strong> échec(s)</>}
                    {progress.errors.length > 0 && !generating && (
                        <ul style={{ margin: '6px 0 0', paddingLeft: 18, fontSize: '0.85em' }}>
                            {progress.errors.map((e, i) => (
                                <li key={i} style={{ color: '#fca5a5' }}>{e.label} : {e.message}</li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </>
    );
}
